import { Component, Input, Inject, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { RoundingSettingsService } from 'src/app/modules/settings/services/rounding-settings.service';
import { RoundingSettings } from 'src/app/core/interfaces/rounding-settings.interface';

@Component({
  selector: 'app-textarea-row',
  templateUrl: './textarea-row.component.html',
  styleUrl: './textarea-row.component.css'
})
export class TextareaRowComponent implements OnInit, OnDestroy {
  @Input({ required: false }) label?: string;
  @Input({ required: true }) placeholder: string;
  @Input({ required: true }) errorMessage: string;
  @Input({ required: true }) control: FormControl;
  @Input({ required: false }) width = "30%";
  @Input({ required: false }) isResponsive = true;

  @Input() iconPath?: string;
  @Input() iconAlt = 'icon';
  @Output() iconClick = new EventEmitter<void>();

  @Input() tabWhenEnter = true;

  @Input() separator = "";

  private destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isInvalid(): boolean {
    const control = this.control;
    return control ? control.invalid && (control.dirty || control.touched) : false;
  }

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private roundingSettingsService: RoundingSettingsService
  ) { }
  ngOnInit(): void {
    // Initialize separator from cached settings
    this.updateSeparatorFromSettings();

    // Subscribe to rounding settings changes to update separator dynamically
    this.roundingSettingsService.getCurrentRoundingSettings$()
      .pipe(takeUntil(this.destroy$))
      .subscribe((settings: RoundingSettings | null) => {
        if (settings) {
          this.updateSeparatorFromSettings(settings);
        }
      });

    this.control.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe({});
  }

  get pageDirection(): string {
    return this.document.documentElement.dir || 'ltr';
  }

  isRtl(): boolean {
    return this.pageDirection.toLowerCase() === 'rtl';
  }

  private updateSeparatorFromSettings(settings?: RoundingSettings): void {
    let displayPrecision = 2; // Default fallback

    if (settings) {
      displayPrecision = settings.displayPrecision;
    } else {
      // Get from service cache first
      const cachedSettings = this.roundingSettingsService.getCurrentRoundingSettings();
      if (cachedSettings) {
        displayPrecision = cachedSettings.displayPrecision;
      }
    }

    this.separator = `separator.${displayPrecision}`;
  }
}
